import React from 'react';

import { Box, Typography, useThemeProps } from '@mui/material';

import { NoteRoot } from './NoteRoot';
import { NoteStatusIcon } from './NoteStatusIcon';

import type { NoteOwnerState, NoteProperties } from './Note.types';

export const Note = React.forwardRef<HTMLDivElement, NoteProperties>(
  function Note(inProperties, reference) {
    const properties = useThemeProps({ props: inProperties, name: 'Note' });
    const {
      dataTest = 'note',
      variant = 'error',
      noteTitle,
      children,
      id,
      sx,
    } = properties;

    const ownerState: NoteOwnerState = { variant };

    return (
      <NoteRoot
        data-testid={dataTest}
        ownerState={ownerState}
        ref={reference}
        id={id ?? dataTest}
        sx={sx}
      >
        <NoteStatusIcon variant={variant} />
        <Box sx={{ flex: 1 }}>
          {noteTitle && (
            <Typography
              data-testid={`${dataTest}_title`}
              sx={{
                fontSize: '0.8125rem',
                fontWeight: 600,
                color: 'text.primary',
                mb: 0.25,
              }}
            >
              {`${noteTitle}:`}
            </Typography>
          )}
          <Typography
            sx={{
              fontSize: '0.8125rem',
              color: 'text.secondary',
              lineHeight: 1.5,
            }}
          >
            {children}
          </Typography>
        </Box>
      </NoteRoot>
    );
  },
);
